export type ColumnPersonalInformationProps = {
  name: string;
  email: string;
  phone?: string;
  onNameClick?: () => void;
  id?: string;
  branchId?: string;
};

const ColumnPersonalInformation: React.FC<ColumnPersonalInformationProps> = ({
  name,
  id,
  branchId,
  email,
  phone,
  onNameClick,
}) => {
  return (
    <>
      <td className="whitespace-nowrap px-3 py-5  text-sm text-gray-500 min-w-80">
        <div className="text-gray-900 cursor-pointer" onClick={onNameClick}>
          {name}
        </div>
        <div className="mt-1 text-gray-500">{email}</div>
        {phone && <div className="mt-1 text-gray-500">{phone}</div>}
      </td>
    </>
  );
};

export default ColumnPersonalInformation;
